import { render, staticRenderFns } from "./ViewOrderCreationModels.vue?vue&type=template&id=80931268&scoped=true&"
import script from "./ViewOrderCreationModels.vue?vue&type=script&lang=ts&"
export * from "./ViewOrderCreationModels.vue?vue&type=script&lang=ts&"
import style0 from "./ViewOrderCreationModels.vue?vue&type=style&index=0&id=80931268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80931268",
  null
  
)

export default component.exports